import type { HebrewDayInfo } from "@kedaat/engine";
import type { Locality } from "@kedaat/locations";
import { formatGregorian } from "@/lib/zmanim";

export function DayHeader({ info, locality }: { info: HebrewDayInfo; locality: Locality }) {
  const chips = [
    info.holiday,
    info.roshChodesh,
    info.chanukahDay ? `נר ${info.chanukahDay} של חנוכה` : null,
    info.omer ? `${info.omer.text} (${info.omer.day})` : null,
    info.specialShabbat ? `שבת ${info.specialShabbat}` : null,
  ].filter((c): c is string => !!c);

  return (
    <section aria-labelledby="day-title" className="space-y-2">
      <p className="text-sm font-medium text-muted">
        {formatGregorian(info.date)} · {locality.nameHe}
      </p>
      <h2 id="day-title" className="font-serif text-4xl font-bold leading-tight sm:text-5xl">
        {info.hebrewDate}
      </h2>
      {(info.weeklyReading || chips.length > 0) && (
        <div className="flex flex-wrap gap-2 text-sm">
          {info.weeklyReading && (
            <span className="rounded-full bg-accent-soft px-3 py-1 font-medium text-accent">
              {info.parsha ? `פרשת ${info.parsha}` : `לקראת שבת: ${info.weeklyReading}`}
            </span>
          )}
          {chips.map((chip) => (
            <span key={chip} className="rounded-full border border-line bg-card px-3 py-1">
              {chip}
            </span>
          ))}
        </div>
      )}
    </section>
  );
}
